import { createSystem, defaultConfig } from "@chakra-ui/react";

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: "MyFont, sans-serif" },
        body: { value: "MyFont, sans-serif" },
      },
    },
  },
});

export default system;
